export const DUPLICATE_SCATTER_POINT_OFFSET = 0.06;

export const SCATTER_DISPLAY_SCORE_FIELD = 'displayScore';
export const SCATTER_DISPLAY_CATEGORY_SCORE_FIELD = 'displayCategoryScore';
